import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "components/fields/InputField";
import { useAuth } from "context/AuthProvider";
import authImg from "assets/img/auth/logo.svg";
import Request from "helpers/request";
function ForgotPassowrd() {
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const [successState, setSuccessState] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [message, setMessage] = useState({});

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Your login action here
      setValidationErrors({});
      // values.preventDefault();
      setIsSubmitting(true);
      Request.postJson("user/forgot-password", values)
        .then((r) => {
          setIsSubmitting(false);
          setIsSent(true);
          setTimeout(() => {
            setIsSent(false);
          }, 1000);
          setMessage(r.data);
        })
        .catch((e) => {
          setIsSubmitting(false);
          if (e.response.data.detail !== undefined) {
            setValidationErrors(e.response.data.detail);
          }
          if (e.response.data.error !== undefined) {
            setValidationErrors(e.response.data.error);
          }
          if (Object.keys(validationErrors).length !== 0) {
            setSuccessState("error");
          }
          console.log(e);
        });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mt-16 mb-16 flex w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        {/* Sign in section */}
        <div className="mt-[20vh] w-full max-w-full flex-col items-center rounded-xl p-6 shadow-[0_0px_6px_rgba(0,0,0,0.1)] xl:max-w-[420px]">
          <img className="mt-[-70px] mr-auto ml-auto bg-white rounded-[50px]" src={authImg} alt="" />
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Forgot Password?
          </h4>
          <p className="mb-4 ml-1 text-base text-gray-600">
            Enter your email address below and we'll email you instructions on
            how to reset your password!
          </p>
          {message.message !== "" && (
            <small className="mt-3 ml-1 text-center text-[12px] text-green-600">
              {message.message}
            </small>
          )}

          {Object.keys(validationErrors).length !== 0 && (
            <small className="mb-3 ml-1 text-center text-red-600">
              {validationErrors.message}
            </small>
          )}
          {/* Email */}
          <div className="mb-3">
            <InputField
              required="*"
              variant="auth"
              extra=""
              label="Email"
              placeholder="mail@johndoe.com"
              id="email"
              type="text"
              name="email"
              value={formik.values.email}
              onchange={formik.handleChange}
              state={formik.touched.email && formik.errors.email ? "error" : ""}
            />
            {formik.touched.email && formik.errors.email && (
              <small className="ml-1.5 text-[12px] text-red-600">
                {formik.errors.email}
              </small>
            )}
          </div>
          <button
            disabled={isSubmitting}
            type="submit"
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {isSubmitting ? "Sending..." : isSent ? "Sent" : "Send"}
          </button>
        </div>
      </div>
    </form>
  );
}
export default ForgotPassowrd;
